module.exports = __webpack_public_path__ + "img/MalaHotpot.6d225636.jpeg";